import React from 'react';
import actions from '../actions';
import store from '../store';
import endpoint from '../helpers/endpoint';
import Form from './Form/Form';

const FORM_NAME = 'ContactForm';
const ENDPOINT = endpoint('contact');

// Add form to Redux
store.dispatch(
  actions.addForm(FORM_NAME)
);

// Set form fields
const fields = formDisabled => {

  const name = {
    grid: 'col-12',
    required: true,
    input: {
      name: 'name',
      type: 'text',
      placeholder: 'Name *',
      maxLength: 100,
      disabled: formDisabled
    }
  };

  const email = {
    grid: 'col-12',
    required: true,
    input: {
      name: 'email',
      type: 'email',
      placeholder: 'Email *',
      maxLength: 100,
      disabled: formDisabled
    }
  };

  const message = {
    grid: 'col-12',
    required: true,
    input: {
      name: 'message',
      type: 'textarea',
      placeholder: 'Message *',
      maxLength: 300,
      disabled: formDisabled
    }
  };

  const submit = {
    grid: 'col-12',
    input: {
      type: 'submit',
      value: 'SEND',
      disabled: formDisabled
    }
  };

  return [
    name,
    email,
    message,
    submit
  ];
}

// Form success handler
const onSuccess = xhr => {
  // console.log('success', JSON.parse(xhr.response), xhr);
};

// Form error handler
const onError = err => {
  // console.warn('error', err);
};

const ContactForm = ({ forms }) => {
  const form = forms[FORM_NAME]
  const formDisabled = !form.enabled;
  return (
    <Form
      form={form}
      name={FORM_NAME}
      url={ENDPOINT}
      fields={fields(formDisabled)}
      onSuccess={onSuccess}
      onError={onError}
      xhrSuccessMsg={'Your message has been sent!'}
      xhrErrorMsg={'There was a problem sending your message.'}
      />
  );
};

ContactForm.propTypes = {
  forms: React.PropTypes.object.isRequired
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js